const baseUrl = `https://ej-projects.vercel.app/api/web`;

export const requestsData = [
    { url: `${baseUrl}`, method: 'post', payload: { moduleName: "dejavu_galleries", limit: 50 } },
    { url: `${baseUrl}`, method: 'post', payload: { moduleName: "dejavu_videos" } },
    { url: `${baseUrl}`, method: 'post', payload: { moduleName: "dejavu_gallery_categories", sorting: [{ id: 'order_by', desc: 1 }] } },
    { url: `${baseUrl}`, method: 'post', payload: { moduleName: "dejavu_clients" } },
    { url: `${baseUrl}`, method: 'post', payload: { moduleName: "dejavu_testimonials", limit: 20 } },
];